import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';

interface SetMaintenanceVisibilityCommand {
  value: boolean;
}

export const setMaintenanceVisibility: GlobalStateCommandFactory<
  SetMaintenanceVisibilityCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.maintenanceRunning = command.value;
  });
};
